// Action Types
export const SUBMIT_GET_LIVE_ACCOUNTS_REQUEST = "SUBMIT_GET_LIVE_ACCOUNTS_REQUEST";
export const SUBMIT_GET_LIVE_ACCOUNTS_SUCCESS = "SUBMIT_GET_LIVE_ACCOUNTS_SUCCESS";
export const SUBMIT_GET_LIVE_ACCOUNTS_FAILURE = "SUBMIT_GET_LIVE_ACCOUNTS_FAILURE";

// Action Creators
export const submitGetLiveAccountsRequest = (formData) => {
  return (dispatch) => {
    dispatch({
      type: SUBMIT_GET_LIVE_ACCOUNTS_REQUEST,
      payload: [],
    });
  };
};

export const submitGetLiveAccountsSuccess = (message) => ({
  type: SUBMIT_GET_LIVE_ACCOUNTS_SUCCESS,
  payload: message,
});

export const submitGetLiveAccountsFailure = (error) => ({
  type: SUBMIT_GET_LIVE_ACCOUNTS_FAILURE,
  payload: error,
});